
import MenuIcon from '@mui/icons-material/Menu'
import { AppBar, Box, Button, Grid, IconButton, Toolbar } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Role } from '../../../types/roles/roleTypes'
import { RoutesMap } from '../../../types'
import { useLocation, useNavigate } from 'react-router-dom'
import Notifications from './Notifications'
import { useDrawerStore } from '../../../hooks/useDrawerStore'
import { useNavSectionStore } from '../../../hooks/useNavSectionStore'
import { useAuthStore } from '../../../hooks/useAuthStore'
import { CustomSearchByTable } from '../CustomSearchByTable/CustomSearchByTable'
import AccountPopover from './AccountPopover'
import ZendyLogo from '../../../assets/image/Zendy-logo.png'

export const HeaderView = (): JSX.Element => {

    const navigate = useNavigate();
    const { pathname } = useLocation();

    //Hooks
    const { user } = useAuthStore();
    const { drawerOpen, openDrawer } = useDrawerStore();
    const { navOpen, openNavSection } = useNavSectionStore();

    const MARGIN_RIGHT = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 16 : 0
    const BORDER_RADIUS = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 10 : 0
    const MARGIN_TOP = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 5 : 0

    const notSearcher = pathname.startsWith("/preview-document/") ||
        pathname.startsWith(RoutesMap.SEARCHER_COMPANY)

    const BACKGROUND_COLOR = '#fff'
    const ICON_COLOR_HEADER = '#7a7a7a'
    const HEADER_MOBILE = 64
    const HEADER_DESKTOP = 50

    const NAV_WIDTH = navOpen ? 310 : 28

    const StyledRoot = styled(AppBar)(({ theme }) => ({
        backgroundColor: BACKGROUND_COLOR,
        border: 'solid 1px #dddddd',
        boxShadow: 'none',
        [theme.breakpoints.up('lg')]: {
            width: `calc(100% - ${NAV_WIDTH}px)`,
            maxHeight: '75px',
            minHeight: '75px',
            marginRight: MARGIN_RIGHT,
            borderRadius: BORDER_RADIUS,
            marginTop: MARGIN_TOP,
            overflow: 'hidden',
            border: 'solid 1px #dddddd',
        },
    }))

    const StyledToolbar = styled(Toolbar)(({ theme }) => ({
        alignItems: 'center',
        minHeight: HEADER_MOBILE,
        [theme.breakpoints.up('lg')]: {
            minHeight: HEADER_DESKTOP,
            padding: theme.spacing(0, 3),
        },
    }))

    const onChangeLogo = () => {
        switch (user.userType) {
            case Role.SUPER_ADMIN:
                // navigate({ pathname: RoutesMap.SUPERVISORS }, { replace: true })
                break
            default:
                break
        }
    }

    const ZENDY_BASE_URL = 'https://www.zendy.cl';

    const COMPANY_KEY = user?.company_zendy_apikey || ""; 
    const ZENDY_API_KEY = user?.zendy_apikey || "";
    const ZENDY_REDIRECT_URL = `${ZENDY_BASE_URL}?api_key_user=${ZENDY_API_KEY}&api_key_company=${COMPANY_KEY}`;


    return (
        <>
            {pathname === RoutesMap.SEARCHER_V2 || pathname === RoutesMap.SEARCHER_V3 ? null : (
                <StyledRoot >
                    <StyledToolbar>

                        <IconButton
                            onClick={() => openDrawer(!drawerOpen)}
                            sx={{
                                mr: 1,
                                color: 'text.primary',
                                display: { lg: 'none', xl: 'none' },
                            }}
                        >
                            <MenuIcon sx={{ color: ICON_COLOR_HEADER }} />
                        </IconButton>

                        <Grid mt={2}>
                            <IconButton
                                onClick={() => openNavSection(!navOpen)}
                                sx={{
                                    mr: 1,
                                    color: 'text.primary',
                                    display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' },
                                }}
                            >
                                <MenuIcon sx={{ color: ICON_COLOR_HEADER }} />
                            </IconButton>
                        </Grid>

                        {<Box sx={{ flexGrow: 1 }} />}
                        {/* {!notSearcher && user?.idcompany != 5 && <CustomSearchByTable />} */}
                        {<Box sx={{ flexGrow: 1 }} />}

                        {
                            user?.zendy_apikey &&
                            <Button
                                onClick={() => window.open(ZENDY_REDIRECT_URL, '_blank')}
                                style={{
                                    backgroundColor: '#fff',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '10px',
                                    padding: '2px 8px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                    marginRight: '12px'
                                }}
                            >
                                <img
                                    src={ZendyLogo}
                                    alt="Zendy"
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        marginRight: '6px',
                                    }}
                                />
                                <span style={{
                                    fontWeight: '600',
                                    fontSize: '13px',
                                    color: '#444'
                                }}>Zendy</span>
                            </Button>

                        }


                        {/* <Grid item xs={2} md={6} mt={3}>
                            <Grid display="flex" justifyContent="flex-end" alignItems="center" container spacing={1} direction="row">
                                <IconButton>
                                    <Notifications />
                                </IconButton>
                            </Grid>
                        </Grid> */}

                        <Grid item xs={2} md={6} mt={3}>
                            <Grid display="flex" justifyContent="flex-end" alignItems="center" container spacing={1} direction="row">
                                <IconButton>
                                    <AccountPopover />
                                </IconButton>
                            </Grid>
                        </Grid>

                    </StyledToolbar>
                </StyledRoot>
            )}
        </>
    )
}